/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { IStackItemStyles } from '@fluentui/react/lib/Stack';
import { ITooltipHostStyles } from '@fluentui/react/lib/Tooltip';
import { DarkColors } from '@msteams/components-fabric-teams-theme/dist/commonjs/src/teams/TeamsColors';
import { Theme } from '../../../common/enums/Theme';
import { FontSizes } from '../../../styles/teams';
import { ContrastColors, CoreColors } from '../../../styles/teams/TeamsColors';
import { getAppHost } from '../../../utilities/TeamsUtils';

export const getStackItemStyles = (visible: boolean = true): Partial<IStackItemStyles> => {
    return {
        root: {
            padding: '0.3em 0',
            display: visible ? 'block' : 'none',
        },
    };
};

export const getTooltipHostStyles = (): Partial<ITooltipHostStyles> => {
    const themeName = getAppHost().getTheme();
    let TEXT_COLOR = CoreColors.appGray03;

    if (themeName === Theme.Dark) {
        TEXT_COLOR = DarkColors.appGray03;
    } else if (themeName === Theme.Contrast) {
        TEXT_COLOR = ContrastColors.appBlack;
    }

    return {
        root: {
            display: 'block',
            alignItems: 'center',
            margin: 'auto',
            selectors: {
                '.toggle-tooltip': {
                    color: TEXT_COLOR,
                    cursor: 'pointer',
                    padding: '0.1rem',
                    outlineColor: CoreColors.appBlack,
                },
            },
        },
    };
};

export const getEnvDropdownStyles = (): Partial<IDropdownStyles> => {
    return {
        label: {
            fontSize: FontSizes.size12,
            fontWeight: 'normal',
            display: 'block',
        },
    };
};
